// Utilities for typography
// e.x. paragraphs, autoscale labels, ....
// ================================================================================================
import * as React from "react";
import { Textfit } from 'react-textfit';
import './Typography.less';
import { isDefined } from "../../Utils/Micro";
// ================================================================================================
export interface LabelAutoSizeProps {
    /**
     * The text that we are going to render in the label
     */
    Text: string | React.ReactNode;

    Width: number;
    Height: number;

    /**
     * Max font size in pt
     */
    MaxFontSize: number;

    /** 
     * whether to decline if multiline mode is on 
     */
    MultiLine?: boolean;

    /**
     * Extra style
     */
    Style?: React.CSSProperties;
}

export function LabelAutoSize(props: LabelAutoSizeProps) {
    if (isDefined(props.Text)) {
        return <div
            id='label-auto-size'
            style={{
                width: props.Width,
                height: props.Height,
                lineHeight: props.MultiLine ? undefined : props.Height + "px",
                ...props.Style
            }}>
            <Textfit
                mode={props.MultiLine ? "multi" : "single"}
                forceSingleModeWidth={false}
                max={props.MaxFontSize}
            >
                {props.Text}
            </Textfit>
        </div>
    }
    return null;
}
// ================================================================================================

export function getRowMinHeight(numRow: number, height: number, minHeight: number, totalVerticalPadding: number): number {
    let fillHeight = minHeight;
    if (numRow == 1) {
        fillHeight = height - totalVerticalPadding;
    } else {
        fillHeight = Math.floor((height - totalVerticalPadding) / numRow);
        if (fillHeight < minHeight)
            fillHeight = minHeight;
    }
    return fillHeight;
}

// ================================================================================================
export interface LabelProp extends React.Props<any> {
    style?: React.CSSProperties
}

export function TypoLabel(props: LabelProp) {
    return <label className="typography-label" style={props.style} >{props.children}</label>
}
// ================================================================================================